import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  constructor(private router: Router) { }

  public handleError = (error: HttpErrorResponse) => {
    if (error.status === 404) {
      this.handle404Error(error);
    }
    else {
      this.handleOtherError(error);
    }
  }

  private handle404Error = (error: HttpErrorResponse) => {
    console.log(error)
    this.router.navigate(['/404']);
  }
  
  private handleOtherError = (error: HttpErrorResponse) => {
    console.log(error)
    this.router.navigate(['/500']);
  }
}
